export default __webpack_public_path__ + "static/personal_1-28a939788ae7486033b56d2dff37e055.png";